<template>
    <div>
        <el-card>
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item>修改密码</el-breadcrumb-item>
            </el-breadcrumb>
        </el-card>
        <el-form :model="editForm" :rules="rules" ref="editFormRef">
            <el-form-item prop="password" label="密码">
                <el-input v-model="editForm.password" type="password"></el-input>
            </el-form-item>
            <el-form-item prop="password1" label="重复密码">
                <el-input v-model="editForm.password1" type="password"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="edit">修改</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
    export default {
        name: "user.vue",
        data(){
            return{
                editForm:{},
                rules:{
                    password: [
                        { required: true, message: '请输入password', trigger: 'blur' },
                    ],
                    password1: [
                        { required: true, message: '请输入password', trigger: 'blur' }
                    ],
                }
            }
        },


        methods:{
            edit() {
                this.$refs.editFormRef.validate(async valid => {
                    if (!valid) {
                        console.log('error submit!!');
                        return false;
                    }
                    if(this.editForm.password!=this.editForm.password1){
                        this.$message.error("密码不一致");
                        return false;
                    }
                    const result=await this.$http.post("user/editpass",this.editForm);
                    console.log(result);
                    if (result.data.error_code!==0){
                        this.$message.error(result.data.msg);
                    }else {
                        this.$message.success(result.data.msg);
                    }
                });
            }

        }
    }
</script>

<style lang="less" scoped>
    .el-table{

    }
    .el-card{
        margin-bottom: 5px;
    }
    .el-table-column{
        padding-left: 10px;
    }
    .el-form{
        width: 100%;
    }
</style>
